import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { useFormik } from "formik";
import * as Yup from "yup";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { addinitiateEmployeeDetails } from "./Service/EmployeeExitService";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeListDetailsByGUID } from "../EmployeeList/Service/employeeService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

function AddInitiateExitEmployee() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const { EmpGUID } = useParams();
  const [employeeMasterReson1TypeData, setEmployeeMasterReson1TypeData] =
    useState([]);
  const [employeeMasterReson2TypeData, setEmployeeMasterReson2TypeData] =
    useState([]);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const toster = useContext(TostMsg);
  let history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [exitEmployeeDetail, setEmployee] = useState([]);
  const [exitTypeId, setExitTypeId] = useState(0);
  const [exitProcessStep1, setExitProcessStep1] = useState([]);
  const [exitProcessStep2, setExitProcessStep2] = useState([]);
  const [exitProcessStep3, setExitProcessStep3] = useState([]);
  const [howItWorkHeader, setHowItWorkHeader] = useState([]);
  const [exitConfirmPopupHeader, setExitConfirmPopupHeader] = useState([]);
  const [exitConfirmPopupText, setExitConfirmPopupText] = useState([]);
  const [isExitSubmitPopup, setIsExitSubmitPopup] = useState(false);

  useEffect(() => {
    GetMasterSystemAlertList();
    getMasterReson1TypeData();
    getMasterReson2TypeData();
    fetchEmployeeIdData();
  }, []);

  async function getMasterReson1TypeData() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "ExitReasons",
    };
    try {
      setIsloading(true);
      const res = await GetMasterTypeData(params);
      setEmployeeMasterReson1TypeData(res?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterReson2TypeData() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "ExitReasons",
    };
    try {
      setIsloading(true);
      const res = await GetMasterTypeData(params);
      setEmployeeMasterReson2TypeData(res?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const initiateExitEmployeeValidation = Yup.object().shape({
    reason1Id: Yup.string().required("Reason 1  is required."),
    reason2Id: Yup.string().required("Reason 2  is required."),
    comment: Yup.string().required("Comment is required."),
    lastWorkingDate: Yup.string().required("Last Working Date is required."),
  });

  async function fetchEmployeeIdData() {
    setIsloading(true);
    var params = {
      GUID: EmpGUID,
    };
    try {
      setIsloading(false);
      let employeesList = await getEmployeeListDetailsByGUID(params);
      setEmployee(employeesList?.Data);
      if (exitEmployeeDetail?.EmpId == userDetails?.EmpId) {
        setExitTypeId(101);
      } else {
        setExitTypeId(102);
      }
    } catch (error) {
      setIsloading(false);
    }
  }

  const initiateExitEmployeeForm = useFormik({
    initialValues: {
      reason1Id: "",
      reason2Id: "",
      comment: "",
      lastWorkingDate: "",
    },
    validationSchema: initiateExitEmployeeValidation,
    onSubmit: async (data) => {
      setIsExitSubmitPopup(true);
    },
  });

  async function exitConfirmSubmit(data) {
     setIsloading(true);
    const body = {
      Id: 0,
      OrgId: exitEmployeeDetail?.OrgId,
      EmpId: exitEmployeeDetail?.EmpId,
      InitiatedDate: new Date().toISOString(),
      LastWorkingDate: new Date(data?.lastWorkingDate).toISOString(),
      Reason1Id: Number(data?.reason1Id),
      Reason2Id: Number(data?.reason2Id),
      Comment: data?.comment,
      ExitTypeId: exitTypeId,
      FnFStatusId: 106,
      IsBuyOut: false,
      StatusId: 101,
    };
    try {
      let res = await addinitiateEmployeeDetails(body);
      setIsloading(false);
      setIsExitSubmitPopup(false);
      if (res.StatusCode == 2000) {
        GetMasterSystemAlertList("ExirRequest_Submit", 0);
      }
      setTimeout(() => {
        history.push(`/Employee/Exit/${res.Data.GUID}`);
      }, 1000);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.ExirRequest);
    }
  }

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
      if (msg?.Name == "OrGenie_HowItWorks_Header") {
        setHowItWorkHeader(msg?.Desc);
      }
      if (msg?.Name == "Employee_ExitProcess_Step1") {
        setExitProcessStep1(msg?.Desc);
      }
      if (msg?.Name === "Employee_ExitProcess_Step2") {
        setExitProcessStep2(msg?.Desc);
      }
      if (msg?.Name === "Employee_ExitProcess_Step3") {
        setExitProcessStep3(msg?.Desc);
      }
      if (msg?.Name === "Confirmation_Dialog_Title1") {
        setExitConfirmPopupHeader(msg?.Desc);
      }
      if (msg?.Name === "Confirmation_Dialog_Body1") {
        setExitConfirmPopupText(msg?.Desc);
      }
    });
  }

  useEffect(() => {
    if (masterSystemAlertData?.length > 0) {
      toster.current.success(masterSystemAlertData[0]?.Desc);
    }
  }, [
    employeeMasterReson1TypeData,
    employeeMasterReson2TypeData,
    masterSystemAlertData,
  ]);

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Initiate Exit</h2>
              <p className="text-light">
                Great if it’s part of a broader HR process
              </p>
            </div>
          </div>
          <div className="edit-ticket mt-4 mb-4 ">
            <div className="w-100">
              <div className="row g-3">
                <div className="col-md-9">
                  <div className="employee-card tile-grid tile-grid-v1">
                    <div id="feed-post-1" className="supp-req">
                      <div className="third-section">
                        <form onSubmit={initiateExitEmployeeForm.handleSubmit}>
                          <div className="row g-3 p-dropdown-border">
                            <div className="col-md-6">
                              <div className="cover-form">
                                <label className="form-label">Reason 01</label>
                                <Dropdown
                                  name="reason1Id"
                                  value={
                                    initiateExitEmployeeForm.values.reason1Id
                                  }
                                  onFocus={(e) => e.target.click()}
                                  onChange={(e) => {
                                    initiateExitEmployeeForm.setFieldValue(
                                      "reason1Id",
                                      e.value
                                    );
                                  }}
                                  options={employeeMasterReson1TypeData}
                                  optionLabel="Name"
                                  optionValue="Id"
                                  filter
                                />
                              </div>
                              <div className="invalid-feedback">
                                {initiateExitEmployeeForm.errors.reason1Id &&
                                initiateExitEmployeeForm.touched.reason1Id
                                  ? initiateExitEmployeeForm.errors.reason1Id
                                  : null}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="cover-form">
                                <label className="form-label">Reason 02</label>
                                <Dropdown
                                  name="reason2Id"
                                  value={
                                    initiateExitEmployeeForm.values.reason2Id
                                  }
                                  onFocus={(e) => e.target.click()}
                                  onChange={(e) => {
                                    initiateExitEmployeeForm.setFieldValue(
                                      "reason2Id",
                                      e.value
                                    );
                                  }}
                                  options={employeeMasterReson2TypeData}
                                  optionLabel="Name"
                                  optionValue="Id"
                                  filter
                                />
                              </div>
                              <div className="invalid-feedback">
                                {initiateExitEmployeeForm.errors.reason2Id &&
                                initiateExitEmployeeForm.touched.reason2Id
                                  ? initiateExitEmployeeForm.errors.reason2Id
                                  : null}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="cover-form">
                                <label className="form-label">Comment</label>
                                <textarea
                                  rows={6}
                                  cols={1}
                                  name="comment"
                                  maxLength={500}
                                  className={
                                    "form-control h-auto" +
                                    (initiateExitEmployeeForm.errors.comment &&
                                    initiateExitEmployeeForm.touched.comment
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={
                                    initiateExitEmployeeForm.handleChange
                                  }
                                  value={
                                    initiateExitEmployeeForm.values.comment
                                  }
                                />
                              </div>
                               <div
                        style={{
                          textAlign: "right",
                          fontSize: "12px",
                          right: "27px",
                          bottom: "1px",
                          color: initiateExitEmployeeForm.values.comment.length === 500 ? "red" : "#555",
                        }}
                      >
                        {initiateExitEmployeeForm.values.comment.length}/{500}
                      </div>
                              <div className="invalid-feedback">
                                {initiateExitEmployeeForm.errors.comment &&
                                initiateExitEmployeeForm.touched.comment
                                  ? initiateExitEmployeeForm.errors.comment
                                  : null}
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="cover-form">
                                <label className="form-label">
                                  Proposed Last working day
                                </label>
                                <input
                                  type="date"
                                  onClick={(e) =>
                                    e.target.showPicker && e.target.showPicker()
                                  }
                                  className={
                                    "form-control" +
                                    (initiateExitEmployeeForm.errors
                                      .lastWorkingDate &&
                                    initiateExitEmployeeForm.touched
                                      .lastWorkingDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="lastWorkingDate"
                                  onChange={(e) => {
                                    initiateExitEmployeeForm.setFieldValue(
                                      "lastWorkingDate",
                                      e.target.value
                                    );
                                  }}
                                  min={
                                    new Date(Date.now())
                                      .toISOString()
                                      .split("T")[0]
                                  }
                                />
                              </div>
                              <div className="invalid-feedback">
                                {initiateExitEmployeeForm.errors
                                  .lastWorkingDate &&
                                initiateExitEmployeeForm.touched.lastWorkingDate
                                  ? initiateExitEmployeeForm.errors
                                      .lastWorkingDate
                                  : null}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <p>
                                HR will confirm your last working day according
                                to company policies.{" "}
                              </p>
                            </div>
                            <div className="col-md-12">
                              <div className="btns-grp text-right">
                                <button type="submit" className="savebutton">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    fill="currentColor"
                                    className="bi bi-check-circle me-2"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path>
                                  </svg>
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="initiate-step">
                    <img
                      src="https://huro.cssninja.io/assets/img/illustrations/widgets/1.svg"
                      style={{ width: "160px" }}
                    />
                    <h4>{howItWorkHeader}</h4>
                    <ul>
                      <li>
                        <span>01</span>
                        <p>
                          {exitProcessStep1}
                          {/* Initiating an exit request triggers stakeholder approval process. */}
                        </p>
                      </li>
                      <li>
                        <span>02</span>
                        <p>
                          {exitProcessStep2}
                          {/* Once accepted, clearances from IT, Finance, HR, and other teams commence. */}
                        </p>
                      </li>
                      <li>
                        <span>03</span>
                        <p>
                          {exitProcessStep3}
                          {/* On the last working day, after all clearances, exit formalities are executed. */}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isExitSubmitPopup && (
        <div
          className="modal fade show custom-modal-area  initiate-confirmation-area"
          id="initiate-confirm-popup"
          tabIndex="-1"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content add-editbadge add-editexperience">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/popup-icons/featured-post.png" />
                </div>
                <button
                  onClick={() => setIsExitSubmitPopup(false)}
                  type="button"
                  className="btn-close m-auto"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body ">
                <h5 className="modal-title text-center">
                  {exitConfirmPopupHeader}
                </h5>
                <p>{exitConfirmPopupText}</p>

                <div className="modal-footer m-auto justify-content-center">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                    onClick={() => setIsExitSubmitPopup(false)}
                  >
                    No, Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click"
                    disabled={Isloading}
                    onClick={() =>
                      exitConfirmSubmit(initiateExitEmployeeForm.values)
                    }
                  >
                   {Isloading ? "Submit..." : "Yes, Submit Resignation"}  
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}

export default AddInitiateExitEmployee;
